// 커뮤니티 글 목록 조회
export interface CommunityPostListItemDto {
    postNo: number; // 작성글 번호
    title: string; // 제목
    content: string; // 내용
    userNo: number; // 작성자 번호
    writer: string; // 작성자명
    viewCount: number; // 조회수
    commentCount: number; // 댓글수
    itemCount: number; // 연결 매물 수
    postedItems: string[]; // 올린 물건 관리번호
    createdAt: string; // 작성일
}

export interface CommunityListResponse {
    list: CommunityPostListItemDto[];
    totalCount: number; // 전체 수
    page: number; // 페이지
    limit: number; // 제한
}

export interface CommunityListFilterType {
    page: number;
    limit: number;
}

// 커뮤니티 글 상세 조회
// 입찰 종류. 1:경매, 2:공매
export type BidType = 1 | 2;

export const BID_TYPE_KOR: Record<number, string> = {
    1: "경매",
    2: "공매",
};

export interface CommunityPostItemDto {
    itemId: string; // 매물 id
    subId: string | null; // 물건 번호
    bidType: BidType; // 입찰 종류. 1:경매, 2:공매
    address: string | null; // 주소
    addressDong: string | null; // 주소 동
    lat: number | null; // 위도
    lng: number | null; // 경도
}

export interface CommunityCommentDto {
    commentNo: number; // 댓글 번호
    userNo: number; // 작성자 번호
    writer: string; // 작성자명
    content: string; // 내용
    createdAt: string; // 작성일
}

export interface CommunityPostDetailDto {
    postNo: number; // 작성글 번호
    title: string; // 제목
    content: string; // 내용
    userNo: number; // 작성자 번호
    writer: string; // 작성자명
    viewCount: number; // 조회수
    commentCount: number; // 댓글수
    createdAt: string; // 작성일
    itemList: CommunityPostItemDto[]; // 연결 매물 목록
    commentList: CommunityCommentDto[]; // 댓글 목록
}
